import homeLearning from "../../../assets/images/home_learning.jpg"
import triangleBg from "../../../assets/images/triangle_bg.png"
import { Link } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { useMediaQuery, BREAKPOINTS } from "../../../hooks/useMediaQuery";

const NumberedItem = ({ number, text, className }) => {
  return (
    <div className={`flex flex-row items-center w-full ${className}`}>
      <div className="p-2 desktop:p-4 bg-tertiary rounded-[40px] border-[10px] border-white flex-col justify-center items-center gap-2.5 inline-flex">
        <div className="w-[17px] text-center text-primary text-title-medium desktop:text-headline-small font-semibold font-inter leading-[16.80px]">{number}</div>
      </div>
      <div className="px-4 rounded-r-lg  py-[7px] justify-start items-center gap-2.5 inline-flex  w-full">
        <div className="text-primary desktop:text-headline-small text-body-large font-semibold font-inter whitespace-normal break-keep">{text}</div>
      </div>

    </div>
  );
};

export default function TargetCustomerSection() {
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  const { ref: sectionRef, inView } = useInView({
    threshold: 0.5,
    triggerOnce: false,
  });
  return (
    <section ref={sectionRef} className="desktop:py-20 py-[39px] desktop:mb-[80px] mb-0 px-[16px] tablet:px-[35px] bg-[#2684FC]/[0.05]">
      <div className="max-w-[1480px] mx-auto flex desktop:flex-row flex-col items-center justify-between tablet:gap-[66px] gap-[30px]">
        <div className="relative flex-[1] flex justify-center items-center desktop:w-full w-[80%] mb-0 tablet:mb-[60px] ">
          <div className="absolute top-0 -left-8 w-full h-full flex justify-center items-center">
            <img src={triangleBg} alt="triangleBg" className="w-full animate-rotate scale-[1.2]" />
          </div>
          <img
            src={homeLearning}
            alt="아나톨레 어학원에서 수업 중인 학생들"
            loading="lazy"
            className="w-full aspect-square object-cover z-[2] shadow-lg"
            style={{ borderRadius: '58% 42% 52% 48% / 46% 54% 46% 54%' }}
          />

        </div>
        <div className="flex-[1] desktop:w-full ">
          <div className="flex-col justify-start gap-10 inline-flex ">
            <div className="flex-col justify-start items-start gap-6 flex">
              <div className={`w-full ${inView ? 'animate-fadeSlideUp' : ''}`}>
                <span className="text-primary desktop:text-display-large text-headline-large font-semibold font-inter">Who is </span>
                <span className="text-secondary desktop:text-display-large text-headline-large font-semibold font-inter">Anatole Academy&nbsp;</span>
                {isDesktop && <br />}
                <span className="text-primary desktop:text-display-large text-headline-large font-semibold font-inter">Good for?</span>
              </div>
              <div className={`w-full text-custom1 desktop:text-headline-large text-title-medium font-semibold font-inter whitespace-normal break-keep ${inView ? 'delay-[2000ms] animate-fadeSlideUp' : ''}`}>
                아나톨레어학원은 유아, 초등, 중등, 고등학생<br />
                모든 단계의 학습자들이 체계적으로<br />
                영어를 배울 수 있도록 설계된 외국어 학원입니다.
              </div>
            </div>
            <div className="flex-col justify-start items-start gap-4 flex">
              <NumberedItem
                number={1}
                text="기초부터 영어 전문가에게 제대로 배우고 싶은 학생"
                style={{ 'animation-delay': inView ? '500ms' : '0ms' }}
                className={inView ? 'animate-fadeSlideRight' : ''}
              />
              <NumberedItem
                number={2}
                text="효과적으로 내신/수능 성적을 향상시키고 싶은 학생"
                style={{ 'animation-delay': inView ? '1000ms' : '0ms' }}
                className={inView ? 'animate-fadeSlideRight' : ''}
              />
              <NumberedItem
                number={3}
                text="영어인증시험 및 각종 영어 대회를 준비하는 학생"
                style={{ 'animation-delay': inView ? '1500ms' : '0ms' }}
                className={inView ? 'animate-fadeSlideRight' : ''}
              />
              <NumberedItem
                number={4}
                text="영어로 의사소통을 원활하게 진행하길 원하는 학생"
                style={{ 'animation-delay': inView ? '2000ms' : '0ms' }}
                className={inView ? 'animate-fadeSlideRight' : ''}
              />
              <NumberedItem
                number={5}
                text="영어로 생각을 논리적으로 표현하고 싶은 학생"
                style={{ 'animation-delay': inView ? '2500ms' : '0ms' }}
                className={inView ? 'animate-fadeSlideRight' : ''}
              />
            </div>
            <Link to="/inquiry" className="">
              <div className={`px-8 py-[18px] bg-primary rounded-lg backdrop-blur-[6px] justify-center items-center gap-2 inline-flex ${inView ? 'animate-heartBeat' : ''}`}>
                <div className="text-primary-background desktop:text-headline-small text-title-medium font-semibold font-inter">입학 문의</div>
              </div>
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
} 